import type GlobalSearchState from 'contexts/GlobalSearch/GlobalSearchState'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import { buildDisplayOnlySearchItem } from '../ListingDrawerSearchUtils'
import { getHotelSearchDateState } from '../ListingDrawerSearchDates'
import type { HotelListingSearchSubmitParams } from './types'

export function createHotelSearchState({ searchValue, searchItem, hotelDateSelection, occupancies }: HotelListingSearchSubmitParams): GlobalSearchState {
  return {
    ...GLOBAL_SEARCH_INITIAL_STATE,
    ...getHotelSearchDateState(hotelDateSelection),
    searchItem: searchItem ?? buildDisplayOnlySearchItem(searchValue),
    occupancies,
  }
}
